<!-- Spinner -->
<ngx-spinner 
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  [fullScreen]="true">
  <p style="color: white; margin-top: 10px;">Loading...</p>
</ngx-spinner>

<!-- BEGIN PAGE  -->
<div *ngIf="gon">
  <router-outlet></router-outlet>
</div>
<!-- END PAGE  -->

<!-- BEGIN THEME CONFIG PANEL-->
<!-- END THEME CONFIG PANEL-->

<!-- SCROLL TOP -->
<div class="to-top" [class.show]="showButton" (click)="scrollToTop()"><i class="fa fa-angle-double-up"></i></div>
<!-- END SCROLL TOP -->